
import React, {useEffect, useState} from 'react';
import {search_count_by_month} from '../../../service/search'
import rombus from '../../../media/rombus.gif'

const SearchDepMonthTable = ({client_id, agent_id, prod_type=null, date_from=null, date_to=null, title=null, sub_title=null, token, timeout=1000}) => {

    const [d, set_data] = useState(null);

    const  popd = (client_id, agent_id, date_from, date_to, prod_type) => {
        const limit = 8;

        setTimeout(() => {
            search_count_by_month(client_id, agent_id, date_from, date_to, prod_type, token).then((d) => {
            if(d != null){
                set_data(JSON.parse(d))
            }
        });   
        }, (timeout));

    }
    

    let cTitle = 'Most Searched Departure Months';
    if(title != null){
        cTitle = title;
    }

    useEffect(() =>{
                set_data(null);
        popd(client_id, agent_id, date_from, date_to, prod_type);
    }, [client_id, agent_id, date_from, date_to, prod_type])

    if(d == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }

    const tblRows = [];
    let c = 0;
    for(const x of d){

        if(c == 5){
            break;
        }
        tblRows.push(<tr><td>{x.month}</td><td>{x.count}</td></tr>);
        c++;
    }

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='tblinf'>
                <table style={{border:'none', width: '100%'}}>
                    <tbody>
                        {tblRows}
                    </tbody>
                </table>
            
            </div>
        </div>
    </div>)

}

export default SearchDepMonthTable
